export default "__VITE_ASSET__1MWRVCsH__"